export enum DataZone {
  DEVELOPMENT = 'nonpii',
  SECURE = 'pii',
  LIVE = 'prod'
}

export const dataZones = Object.values<DataZone>(DataZone);
